import React from "react";
import "../styles/Footer.css";

export default function Footer() {
  return (
    <footer id="main-footer">
      <small>
        {" "}
        Made with ❤️ by <br/>
        <a
          href="https://github.com/senseilein"
          target="_blank"
          rel="noreferrer"
        >
          🐼Sansi
        </a>
        ,{" "}
        <a href="https://github.com/Maks6831" target="_blank" rel="noreferrer">
          🐯Muhammad
        </a>{" "}
        &{" "}
        <a href="https://github.com/Bcott93" target="_blank" rel="noreferrer">
          😺Benjamin
        </a>
      </small>
    </footer>
  );
}
